import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { makeStyles, Paper as Paper$1 } from '@material-ui/core';

var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            '&:last-child': {
                marginBottom: 0,
            },
            marginBottom: spacing(4),
            padding: spacing(4),
        },
    });
});
var Paper = forwardRef(function (props, ref) {
    var legacyStyles = props.legacyStyles, restProps = __rest(props, ["legacyStyles"]);
    var classes = useStyles(props);
    return React.createElement(Paper$1, __assign({}, ref, { classes: __assign({}, (legacyStyles && classes)) }, restProps));
});
Paper.displayName = 'Paper';
Paper.defaultProps = {
    legacyStyles: false,
};

export { Paper };
//# sourceMappingURL=Paper.js.map
